import { Checkbox, SearchBar } from '@/components/Common';
import { useFilterStore } from '@/store/useFilterOptionsStore';

interface FilterOptionsListProps {
  categories: {
    id: string;
    label: string;
    count: number;
    hasSearch?: boolean;
  }[];
  options: {
    id: string;
    value: string;
    label: string;
  }[];
  selectedOptions: string[];
  onOptionToggle: (value: string) => void;
  selectedCategory: string;
  onCategorySelect: (categoryId: string) => void;
  getSelectedCount: (categoryId: string) => number;
}

const FilterOptionsList = ({
  categories,
  options,
  selectedOptions,
  onOptionToggle,
  selectedCategory,
  onCategorySelect,
  getSelectedCount,
}: FilterOptionsListProps) => {
  const { setSearchTerm, searchTerm } = useFilterStore();
  const currentCategory = categories.find((cat) => cat.id === selectedCategory);

  return (
    <div className="flex gap-2">
      <div className="flex flex-col gap-[13.24px]">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategorySelect(category.id)}
            className={`
              relative w-[120.93px] h-[49.43px] 
              bg-[#232323] rounded-[15.9px] 
              ${selectedCategory === category.id ? 'border border-primary text-primary font-semibold text-[13px]' : 'text-white'}
              transition-all duration-200 cursor-pointer
            `}
          >
            {getSelectedCount(category.id) > 0 && (
              <span className="absolute top-[6.86px] right-[5.87px] text-black text-[10px] size-[15px] bg-primary rounded-full flex items-center justify-center font-semibold">
                {getSelectedCount(category.id)}
              </span>
            )}
            <div className="h-full flex items-center justify-center">
              {category.label}
            </div>
          </button>
        ))}
      </div>

      <div className="flex-1 ml-6">
        {currentCategory?.hasSearch && (
          <div className="mb-4">
            <SearchBar
              placeholder={`Rechercher un(e) ${currentCategory?.label.toLowerCase()}...`}
              value={searchTerm}
              handleChange={(e) => setSearchTerm(e.target.value ?? '')}
              className="w-full"
            />
            <p className="text-white text-[17.65px] font-semibold mt-[25.2px]">
              Toutes les {currentCategory?.label.toLowerCase()}
            </p>
          </div>
        )}
        <ul className="flex flex-col gap-2 max-h-[350px] overflow-y-auto pr-2">
          {options.map((option) => (
            <li key={option.id}>
              <Checkbox
                value={option.value}
                checked={selectedOptions.includes(option.value)}
                onClick={() => onOptionToggle(option.value)}
                label={option.label}
                styleLabel="!text-[#ADADB1]"
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FilterOptionsList;
